<template>
    <div id="sdslcontent" :class="screenParm" :style="{ width:clientW+'px',height:clientH+'px' }">
        <div id="root" :style="{ width:clientW+'px',height:clientH+'px' }">
            <div class="scrollbox">
                <div class="imglist"><img :src="imgPath+'sdkj_content_1.jpg'"></div>
                <div class="imglist"><img :src="imgPath+'sdkj_content_2.jpg'"></div>
                <div class="contentlist">
                    <img :src="imgPath+'sdkj_cimg1.png'">
                    <a href="https://t.shundecity.com/tzsd2020.php/home/album/p11.html" class="sdkj_link">
                        <img :src="imgPath+'sdkj_cimg2.png'" class="sdkj_cimg">
                    </a>
                </div>
                <div class="contentlist">
                    <img :src="imgPath+'sdkj_cimg3.png'">
                    <a href="https://t.shundecity.com/tzsd2020.php/home/album/p12.html" class="sdkj_link">
                        <img :src="imgPath+'sdkj_cimg4.png'" class="sdkj_cimg">
                    </a>
                </div>
                <div class="imglist"><img :src="imgPath+'sdkj_content_3.jpg'"></div>
                <div class="headrpostion" id="scyd_here1"></div>
                <div class="zhenjielist mt58">
                    <a @click="visitWeb('scyd_here1')" class="zhenjie_link">
                        <img :src="imgPath+'zhenjie_daliang.png'" alt="大良">
                    </a>
                </div>
                <div class="headrpostion" id="scyd_here2"></div>
                <div class="zhenjielist mt58">
                    <a @click="visitWeb('scyd_here2')" class="zhenjie_link">
                        <img :src="imgPath+'zhenjie_ronggui.png'" alt="容桂">
                    </a>
                </div>
                <div class="headrpostion" id="scyd_here3"></div>
                <div class="zhenjielist mt58">
                    <a @click="visitWeb('scyd_here3')" class="zhenjie_link">
                        <img :src="imgPath+'zhenjie_lunjiao.png'" alt="伦教">
                    </a>
                </div>
                <div class="headrpostion" id="scyd_here4"></div>
                <div class="zhenjielist mt58">
                    <a @click="visitWeb('scyd_here4')" class="zhenjie_link">
                        <img :src="imgPath+'zhenjie_leliu.png'" alt="勒流">
                    </a>
                </div>
                <div class="headrpostion" id="scyd_here5"></div>
                <div class="zhenjielist mt58">
                    <a @click="visitWeb('scyd_here5')" class="zhenjie_link">
                        <img :src="imgPath+'zhenjie_chencun.png'" alt="陈村">
                    </a>
                </div>
                <div class="headrpostion" id="scyd_here6"></div>
                <div class="zhenjielist mt58">
                    <a @click="visitWeb('scyd_here6')" class="zhenjie_link">
                        <img :src="imgPath+'zhenjie_beijiao.png'" alt="北滘">
                    </a>
                </div>
                <div class="headrpostion" id="scyd_here7"></div>
                <div class="zhenjielist mt58">
                    <a @click="visitWeb('scyd_here7')" class="zhenjie_link">
                        <img :src="imgPath+'zhenjie_lecong.png'" alt="乐从">
                    </a>
                </div>
                <div class="headrpostion" id="scyd_here8"></div>
                <div class="zhenjielist mt58">
                    <a @click="visitWeb('scyd_here8')" class="zhenjie_link">
                        <img :src="imgPath+'zhenjie_longjiang.png'" alt="龙江">
                    </a>
                </div>
                <div class="headrpostion" id="scyd_here9"></div>
                <div class="zhenjielist mt58">
                    <a @click="visitWeb('scyd_here9')" class="zhenjie_link">
                        <img :src="imgPath+'zhenjie_xingtan.png'" alt="杏坛">
                    </a>
                </div>
                <div class="headrpostion" id="scyd_here10"></div>
                <div class="zhenjielist mt58">
                    <a @click="visitWeb('scyd_here10')" class="zhenjie_link">
                        <img :src="imgPath+'zhenjie_junan.png'" alt="均安">
                    </a>
                </div>
                <div class="back" @click="black">
                <img :src="imgPath+'back.png'" alt="">
            </div>
            </div>
            
        </div>
        <transition name="van-fade">
            <div class="bs_bg" v-show="showloading" :style="{ width:clientW+'px',height:clientH+'px' }"></div>
        </transition>
    </div>
</template>
<script>
    // 蝴蝶 闪光
    export default {
        data () {
            return {
                winScreenW:window.screen.width,                 // 宽度 
                winScreenH:window.screen.height,                // 高度
                clientW:document.body.clientWidth,              // 可视区高度
                clientH:document.body.clientHeight,             // 可视区高度
                screenParm: "",                                 // 屏幕参数
                topPx:0,
                isjcw: true,                                    // 布局参数 
                isjc: false,                                    // 布局参数
                imgPath:imgPath,
                footerBottom:-0.6,
                themeMtop:0.25,
                zbdwMbottom:0,
                themeWidth:13.5,
                showloading:true,
                showhere:0
            }
        },
        // 生命周期被创建
        created () {
            this.getViewScale();
        },
        mounted () {
            var _this = this;
            this.$nextTick(() => {
                var browser = {
                    versions: function() {
                    var u = navigator.userAgent,
                        app = navigator.appVersion;
                    return { //移动终端浏览器版本信息
                        trident: u.indexOf('Trident') > -1, //IE内核
                        presto: u.indexOf('Presto') > -1, //opera内核
                        webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
                        gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
                        mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
                        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
                        android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或uc浏览器
                        iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
                        iPad: u.indexOf('iPad') > -1, //是否iPad
                        webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
                        wx:u.match(/MicroMessenger/i) == "MicroMessenger",
                        qq:u.toLowerCase().toString().indexOf('qq')>-1
                    };
                    }(),
                    language: (navigator.browserLanguage || navigator.language).toLowerCase()
                }
                if(browser.versions.ios){
                    // document.body.removeEventListener('touchmove',bingEvent,{passive: false});
                    //判断android终端或uc浏览器
                }
                _this.visitNow();
                
            });
        },
        // 事件或方法
        methods:{

            getViewScale: function() {
                var _this = this;
                if(this.clientW > 414){
                    this.clientW = 414;
                    this.clientH = 736;
                }
                if(this.clientH/this.clientW > 1.5 && this.clientH/this.clientW < 1.6){
                    // 320*504
                    this.screenParm = "smallScreen"; 
                }else if(this.clientH/this.clientW <= 1.5){
                    //  320*416
                    this.screenParm = "superSmallScreen";
                }else if(this.clientH/this.clientW >= 1.8){
                    // 414*745
                    // 360*648
                    // 375*675
                    // 320*576
                    this.screenParm = "bigScreen";
                    this.footerBottom = 0;
                    this.themeMtop = 1.75;
                    this.zbdwMbottom = 1.5;
                    this.themeWidth = 14.5;
                }else{
                    // 360*576
                    // 320*512
                    // 375*600
                    // 414*663
                    this.screenParm = "middleScreen";
                }
                if (this.clientH/this.clientW < 1202/750) {
                    var tpdzsgd = this.clientW * 1202/750;
                    this.topPx = -Math.floor(tpdzsgd - this.clientH);
                    this.isjcw = true;
                    this.isjc = false;
                } else {
                    this.isjcw = false;
                    this.isjc = true;
                }
            },

            toSdsl () {
                this.$router.replace({path:'/sdsl'}); 
            },

            toSdcy () {
                this.$router.replace({path:'/sdcy'});
            },

            getStore:function(name){
                if (!name) return;
                return window.localStorage.getItem(name);
            },

            setStore (name, content) {
                if (!name) return;
                if (typeof content !== 'string') {
                    content = JSON.stringify(content);
                }
                window.localStorage.setItem(name, content);
            },

            deleteStore (name) {
                if (!name) return;
                window.localStorage.removeItem(name);
            },

            visitWeb (url){
                if(url == "scyd_here1"){
                    this.setStore("tzsdReturnCs","scyd_here1");
                    window.location.href = "https://t.shundecity.com/tzsd2020.php/home/album/p1.html";
                }else if(url == "scyd_here2"){
                    this.setStore("tzsdReturnCs","scyd_here2");
                    window.location.href = "https://t.shundecity.com/tzsd2020.php/home/album/p2.html";
                }else if(url == "scyd_here3"){
                    this.setStore("tzsdReturnCs","scyd_here3");
                    window.location.href = "https://t.shundecity.com/tzsd2020.php/home/album/p3.html";
                }else if(url == "scyd_here4"){
                    this.setStore("tzsdReturnCs","scyd_here4");
                    window.location.href = "https://t.shundecity.com/tzsd2020.php/home/album/p4.html";
                }else if(url == "scyd_here5"){
                    this.setStore("tzsdReturnCs","scyd_here5");
                    window.location.href = "https://t.shundecity.com/tzsd2020.php/home/album/p5.html";
                }else if(url == "scyd_here6"){
                    this.setStore("tzsdReturnCs","scyd_here6");
                    window.location.href = "https://t.shundecity.com/tzsd2020.php/home/album/p6.html";
                }else if(url == "scyd_here7"){
                    this.setStore("tzsdReturnCs","scyd_here7");
                    window.location.href = "https://t.shundecity.com/tzsd2020.php/home/album/p7.html";
                }else if(url == "scyd_here8"){
                    this.setStore("tzsdReturnCs","scyd_here8");
                    window.location.href = "https://t.shundecity.com/tzsd2020.php/home/album/p8.html";
                }else if(url == "scyd_here9"){
                    this.setStore("tzsdReturnCs","scyd_here9");
                    window.location.href = "https://t.shundecity.com/tzsd2020.php/home/album/p9.html";
                }else if(url == "scyd_here10"){
                    this.setStore("tzsdReturnCs","scyd_here10");
                    window.location.href = "https://t.shundecity.com/tzsd2020.php/home/album/p10.html";
                }
            },

            black(){
                this.$router.back(-1);//放回上一页
            },

            visitNow () {
                var tzsdReturnCs = this.getStore("tzsdReturnCs");
                var _this = this;
                if(tzsdReturnCs == "scyd_here1"){
                    setTimeout(function(){
                        document.getElementById("scyd_here1").scrollIntoView();
                        _this.showhere = 1;
                        _this.showloading = false;
                        _this.deleteStore("tzsdReturnCs");
                    },100)
                }else if(tzsdReturnCs == "scyd_here2"){
                    setTimeout(function(){
                        document.getElementById("scyd_here2").scrollIntoView();
                        _this.showhere = 2;
                        _this.showloading = false;
                        _this.deleteStore("tzsdReturnCs");
                    },100)
                }else if(tzsdReturnCs == "scyd_here3"){
                    setTimeout(function(){
                        document.getElementById("scyd_here3").scrollIntoView();
                        _this.showhere = 3;
                        _this.showloading = false;
                        _this.deleteStore("tzsdReturnCs");
                    },100)
                }else if(tzsdReturnCs == "scyd_here4"){
                    setTimeout(function(){
                        document.getElementById("scyd_here4").scrollIntoView();
                        _this.showhere = 4;
                        _this.showloading = false;
                        _this.deleteStore("tzsdReturnCs");
                    },100)
                }else if(tzsdReturnCs == "scyd_here5"){
                    setTimeout(function(){
                        document.getElementById("scyd_here5").scrollIntoView();
                        _this.showhere = 5;
                        _this.showloading = false;
                        _this.deleteStore("tzsdReturnCs");
                    },100)
                }else if(tzsdReturnCs == "scyd_here6"){
                    setTimeout(function(){
                        document.getElementById("scyd_here6").scrollIntoView();
                        _this.showhere = 6;
                        _this.showloading = false;
                        _this.deleteStore("tzsdReturnCs");
                    },100)
                }else if(tzsdReturnCs == "scyd_here7"){
                    setTimeout(function(){
                        document.getElementById("scyd_here7").scrollIntoView();
                        _this.showhere = 7;
                        _this.showloading = false;
                        _this.deleteStore("tzsdReturnCs");
                    },100)
                }else if(tzsdReturnCs == "scyd_here8"){
                    setTimeout(function(){
                        document.getElementById("scyd_here8").scrollIntoView();
                        _this.showhere = 8;
                        _this.showloading = false;
                        _this.deleteStore("tzsdReturnCs");
                    },100)
                }else if(tzsdReturnCs == "scyd_here9"){
                    setTimeout(function(){
                        document.getElementById("scyd_here9").scrollIntoView();
                        _this.showhere = 9;
                        _this.showloading = false;
                        _this.deleteStore("tzsdReturnCs");
                    },100)
                }else if(tzsdReturnCs == "scyd_here10"){
                    setTimeout(function(){
                        document.getElementById("scyd_here10").scrollIntoView();
                        _this.showhere = 10;
                        _this.showloading = false;
                        _this.deleteStore("tzsdReturnCs");
                    },100)
                }else{
                    _this.showloading = false;
                }
            }
        }
    }
</script>

<style lang="less" scoped> 
    @base:46.875rem;
    #sdslcontent{
        margin: 0 auto;
        position: relative;
        left: 0px;
        top: 0px;
        overflow: hidden;
        z-index: 1;
        background: #0e1f51;
    }
    .scrollbox{
        width: 100%;
        height: 100%;
        overflow-y: scroll;
        -webkit-overflow-scrolling: touch;
        padding-bottom: 215/@base;
    }
    .fixfooterbox{
        width: 100%;
        height: 115/@base;
        background: #c8a062;
        position: fixed;
        left: 0;
        bottom: 0;
        z-index: 999;
    }
    .footernavcon{
        float: left;
        width: 33.333333%;
        height: 115/@base;
        line-height: 115/@base;
        font-size: 0.8rem;
        color: #fff;
        text-align: center;
        &.active{
            text-decoration: underline;
            font-weight:bold;
        }
    }
    .imglist{
        width: 100%;
        display: block;
        img{
            width: 100%;
            display: block;
        }
    }
    .contentlist{
        padding: 0 51/@base;
        margin-top: 37/@base;
        img{
            width: 100%;
            display: block;
        }
    }
    .sdkj_link{
        width: 100%;
        display: block;
    }
    .sdkj_cimg{
        margin-top: 17/@base;
    }
    .zhenjielist{
        padding: 0 21/@base;
        &.mt58{
            margin-top: 58/@base;
        }
    }
    .zhenjie_link{
        width: 100%;
        display: block;
    }
    .scyd_here{
        text-align: center;
        
        line-height: 1.6rem !important;
        font-size: 0.72rem;
        color: red !important;
        font-weight: bold;
        height: 1.6rem;
        border: 1px solid red;
        width: 95%;
        margin: 0 auto;
        margin-top: 1.23733333rem;
        border-radius: 5px;
    }
    .bs_bg{
        position: fixed;
        z-index: 99999999999;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        background: #fff;
    }
    .headrpostion{
        width: 100%;
        height: 0px;
        opacity: 0;
    }
    .back{
        width: 113/@base;
        margin: 20/@base auto;
        padding-bottom: 20/@base;
        z-index: 999;
    }
</style>


// WEBPACK FOOTER //
// src/pages/SdkjContent.vue